module.exports = __webpack_public_path__ + "static/media/picTime@2x.f440ee48.png";